import { fillRouteWithSlugs } from "@utils";
import { ROUTES, ROUTE_SLUGS } from "src/config/navigation/routes";

export const DEVICE_MODAL_SEARCH_PARAM = "device_modal";

export type DeviceCreationModalPanel = "import" | "custom";

export const addDeviceModalSearchParam = (
  modalPanel: DeviceCreationModalPanel
) => {
  return `?${DEVICE_MODAL_SEARCH_PARAM}=${
    modalPanel === "import" ? "0" : "1"
  }`;
};

export const buildDeviceManagementSettingsPath = ({
  orgId,
  modalPanel,
}: {
  orgId: string;
  modalPanel?: DeviceCreationModalPanel;
}) => {
  const settingsPath = fillRouteWithSlugs(ROUTES.MANAGE_ORGANIZATION, {
    [ROUTE_SLUGS.ORG_ID]: orgId,
  });

  return modalPanel
    ? `${settingsPath}${addDeviceModalSearchParam(modalPanel)}`
    : settingsPath;
};
